<template>
  <div class="tile is-ancestor">
    <div class="tile is-vertical is-12">
      <div class="tile is-child is-parent">
        <article class="tile is-child">
          <section>
            <div v-for="candidate in candidates">
              <transition
                name="component-fade"
                mode="out-in"
              >
                <component
                  :is="schoolingItemsView"
                  :candidate="candidate"
                  :order="order"
                  :status="'complete'"
                />
              </transition>
            </div>
            <div>
              <transition
                name="component-fade"
                mode="out-in"
              >
                <component
                  :is="offerItemsView"
                  :order="order"
                  :status="'complete'"
                />
              </transition>
            </div>

            <footer class="box">
              <span class="card-footer-item"><span><i>{{ $t('offers.cart.price') }} :</i>
                <strong>{{ order.payment_total > 0 ? order.payment_total : 0 }} {{
                  order.payment_currency
                }}</strong></span></span>

              <promo-code-display
                :promo="order.promoCodes[0]"
                :has-fees="order.order_status === 'complete'"
              />
            </footer>
          </section>

          <section
            id="payment-view"
            class="box"
          >
            <transition
              name="component-fade"
              mode="out-in"
            >
              <component
                :is="paymentView"
                :order="order"
                :guarantor="guarantor"
                @send="savePayment"
                @edit="editPayment"
              />
            </transition>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import OrderConfirmation from './OrderConfirmation.vue'
import SchoolingItemsView from '../orders/SchoolingItems'
import OfferItemsView from '../orders/OfferItems'
import PromoCodeDisplay from "../../../components/application/PromoCodeDisplay.vue";

export default {
  components: {PromoCodeDisplay},
  props: {
    candidates: {type: Array},
    order: {type: Object}
  },
  data() {
    return {
      schoolingItemsView: SchoolingItemsView,
      offerItemsView: OfferItemsView,
      paymentView: OrderConfirmation,
      checkboxContract: false,
      guarantor: null,
    }
  },
  computed: {},
  methods: {
    savePayment() {
      this.paymentView = OrderConfirmation
      this.$scrollTo('#payment-view', {offset: -10}, 200)
    },
    editPayment() {
      this.paymentView = OrderPayments
    },
  }
}
</script>

<style scoped>

</style>
